<template>
<md-card>
    <header-form title="CADASTRAR DE GRUPO DE EMPRESAS" :rota="{name: 'grupo_empresasRead'}" tooltip="Lista de Grupo de Empresas" />

    <form @submit.prevent="create">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-80 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nome }">
                        <label>NOME</label>
                        <md-input v-model="dados.nome" type="text" class="uppercase"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nome">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nome" class="validErro"> {{ errors.nome[0] }}</div>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.dia_pgto }">
                        <label>DIA DE PAGAMENTO</label>
                        <md-input v-model="dados.dia_pgto" type="text" class="uppercase"> </md-input>

                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.dia_pgto">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.dia_pgto" class="validErro"> {{ errors.dia_pgto[0] }}</div>
                </div>
            </div>
        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-success md-round">
                <span class="md-label">
                    <md-icon class="material-icons">check</md-icon>
                </span>SALVAR
            </md-button>
        </md-card-actions>
    </form>
</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {},
            errors: {}
        }
    },
    mixins: [Notify],
    methods: {
        create() {
            this.$http.post(this.$urlAPI + 'grupo_empresas', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.$router.push({
                            name: 'grupo_empresasRead'
                        })
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                        let erros = ''
                        for (let erro of Object.values(response.data.errors)) {
                            erros += "<li>" + erro + "</li>";
                        }
                        this.danger("<ul>" + erros + "</ul>")
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    }
};
</script>
